import React, { useState, useEffect } from 'react';

export default function MetricCard({
  title,
  value,
  subtitle,
  color = 'text-white',
  percentage,
  progressColor = 'bg-gradient-to-r from-blue-400 to-blue-800',
  showPercentage = false,
}) {
  const hasProgress = typeof percentage === 'number' && percentage >= 0 && percentage <= 100;
  percentage = Math.min(100, percentage);
  value = typeof value == 'number' ? Number(value || 0).toFixed(1) : value;

  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (hasProgress) {
      setTimeout(() => {
        setWidth(percentage);
      }, 50); // small delay triggers transition
    }
  }, [percentage]);

  return (
    <div className="bg-gray-800 rounded-2xl p-4 sm:p-5 shadow hover:shadow-lg transition relative overflow-hidden">
      {hasProgress && (
        <div
          className={`absolute inset-y-0 left-0 ${progressColor} opacity-20 transition-all duration-1000 ease-out`}
          style={{ width: `${width}%` }}
        />
      )}

      <div className="relative z-10">
        <div className="text-gray-400 text-sm font-medium">{title}</div>

        <div className="flex items-baseline justify-between mt-2">
          <div className={`text-2xl sm:text-3xl font-bold ${color}`}>
            {value}
          </div>

          {hasProgress && showPercentage && (
            <div
              className="absolute text-2xl sm:text-3xl lg:text-7xl font-black tracking-tight"
              style={{
                color: "#94a3b8",
                right: 0,
                top: 0,
                opacity: "20%"
              }}
            >
              {Math.round(percentage)}%
            </div>
          )}
        </div>

        {subtitle && (
          <div className="text-gray-500 text-sm mt-1">{subtitle}</div>
        )}
      </div>
    </div>
  );
}
